import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function UnsubscribeDialog(props) {

  const [feedback, setFeedback] = useState("");

  const handleChangeFeedback = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setFeedback(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      props.onCancellation(feedback);
    }
  };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogTitle sx={{ marginBottom: "0 !important", paddingBottom: "0 !important" }}>{TR.cm_cancel}</DialogTitle>
      <DialogContent sx={{ marginTop: "0 !important", paddingTop: "0 !important" }}>
        <p>{TR.cm_cancel_reason_question}</p>
        <TextField
          sx={{ width: "100%" }}
          multiline
          rows={2}
          onKeyDown={(e) => {

            e.stopPropagation();
          }}
          onChange={handleChangeFeedback}
        />
        <p>d</p>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_do_not_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => props.onCancellation(feedback)}>{TR.cm_cancel_subscription}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default UnsubscribeDialog;